import React from 'react';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form/immutable';
import {
  Card,
  CardBody,
  CardTitle,
  Button,
} from 'reactstrap';
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindActionCreators } from 'redux';
import { Loading } from '../../../../../loadbar/Loading';
import { LabeledText } from '../../../../../form/LabeledText';
import { LabeledSelect } from '../../../../../form/LabeledSelect';
import {
  clearTsunami as clearTsunamiAc,
  searchReferences as searchReferencesAc,
  getReferences as getReferencesAc,
  getTsunami as getTsunamiAc,
  searchVolcanoes as searchVolcanoesAc,
  getVolcano as getVolcanoAc,
  getEarthquake as getEarthquakeAc,
  searchEarthquakes as searchEarthquakesAc,
  createTsunami as createTsunamiAc,
  updateTsunami as updateTsunamiAc,
  getLocations as getLocationsAc,
  getCountries as getCountriesAc,
  getRegions as getRegionsAc,
  getAreas as getAreasAc,
  getCauses as getCausesAc,
  getValidity as getValidityAc,
  getWarningStatuses as getWarningStatusesAc,
  sortVolcanoes as sortVolcanoesAc,
  sortEarthquakes as sortEarthquakesAc,
  sortReferences as sortReferencesAc,
  openEditConfirmation as openEditConfirmationAc,
  cancelEditConfirmation as cancelEditConfirmationAc,
  toggleEarthquakeColumns as toggleEarthquakeColumnsAc,
  toggleReferenceColumns as toggleReferenceColumnsAc,
  toggleVolcanoColumns as toggleVolcanoColumnsAc,
} from '../../../../../../redux/tsunamis/event/edit/tsunamiEventEditActions';
import { tsunamiEventEditModel, createInitialForm, formToJson } from './tsunamiEventEditModel';
import { LabeledCheckbox } from '../../../../../form/LabeledCheckbox';
import { AssociatedVolcanoControl } from '../../../../../form/AssociatedVolcanoControl';
import { AssociatedEarthquakeControl } from '../../../../../form/AssociatedEarthquakeControl';
import { AssociatedReferenceControl } from '../../../../../form/AssociatedReferenceControl';
import { CommentsEditor } from '../../../../../form/CommentsEditor';
import { EditForm } from '../../../../../form/EditForm';

const model = tsunamiEventEditModel.get('name');
const initialValues = tsunamiEventEditModel.get('initialValues');

class TusnamiEditPageUnwrapped extends React.Component {
  constructor(props) {
    super(props);
    this.resetForm = this.resetForm.bind(this);
    this.cancel = this.cancel.bind(this);
    this.state = {
      initialized: false,
      isAdd: false,
    };
  }

  componentDidMount() {
    document.title = 'NCEI Hazard Tsunami Event Edit';
    const {
      match: { params: { id } },
      getEarthquake,
      getVolcano,
      getTsunami,
      getReferences,
      getAreas,
      getCauses,
      getCountries,
      getLocations,
      getRegions,
      getValidity,
      getWarningStatuses,
      history,
    } = this.props;
    const isAdd = !id;
    const state = {
      isAdd,
    };
    if (id) {
      getEarthquake({ id, history });
      getVolcano({ id, history });
      getTsunami({ id, history });
      getReferences({ id, history });
    }
    getLocations({ history });
    getRegions({ history });
    getValidity({ history });
    getWarningStatuses({ history });
    getAreas({ history });
    getCauses({ history });
    getCountries({ history });
    this.setState(state);
  }

  componentDidUpdate() {
    const { fetched, initializeForm, tsunami } = this.props;
    const { initialized } = this.state;
    if (!initialized) {
      if (fetched) {
        const form = createInitialForm(tsunami);
        initializeForm(form);
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ initialized: true });
      }
    }
  }

  componentWillUnmount() {
    const {
      resetForm, initializeForm, setPristine, clearTsunami,
    } = this.props;
    clearTsunami();
    initializeForm(initialValues);
    resetForm();
    setPristine();
  }

  resetForm() {
    const {
      resetForm, setPristine, change, tsunami,
    } = this.props;
    resetForm();
    // There seems to be a bug in react-redux-form. This needs to be called to set the original references.
    change('', createInitialForm(tsunami));
    setPristine();
  }

  cancel() {
    const { history } = this.props;
    history.goBack();
  }


  render() {
    const { isAdd, initialized } = this.state;
    const {
      pristine,
      updating,
      volcano,
      earthquake,
      searchReferences,
      references,
      referenceSearching,
      referenceSearchResults,
      searchEarthquakes,
      earthquakeSearching,
      earthquakeSearchResults,
      volcanoSearching,
      volcanoSearchResults,
      searchVolcanoes,
      areas,
      regions,
      countries,
      warningStatuses,
      causes,
      validities,
      locations,
      peopleDescriptors,
      damageDescriptors,
      housesDescriptors,
      volSort,
      sortVolcanoes,
      eqSort,
      sortEarthquakes,
      refSort,
      sortReferences,
      match: { params: { id } },
      history,
      createTsunami,
      updateTsunami,
      formData,
      editConfirmationOpen,
      cancelEditConfirmation,
      openEditConfirmation,
      tsunami,
      toggleEarthquakeColumns,
      toggleReferenceColumns,
      toggleVolcanoColumns,
      eqVisibleColumns,
      refVisibleColumns,
      volVisibleColumns,

    } = this.props;
    if (!initialized) {
      return (<Loading />);
    }

    const peopleDescriptorsJs = peopleDescriptors.toJS();
    const damageDescriptorsJs = damageDescriptors.toJS();
    const housesDescriptorsJs = housesDescriptors.toJS();

    return (
      <div className="haz-results-container  haz-page-container">
        <Card className="haz-page-card">
          <CardBody>
            <CardTitle tag="h1" className="haz-page-card-title">{isAdd ? 'Add Tsunami Event' : `Edit Tsunami Event: ${id}`}</CardTitle>

            <EditForm
              model={model}
              hazardName="Tsunami"
              saving={updating}
              create={createTsunami}
              update={updateTsunami}
              isAdd={isAdd}
              id={id || '-1'}
              formData={formData}
              editConfirmationOpen={editConfirmationOpen}
              handleOpen={form => openEditConfirmation({ formData: formToJson(form) })}
              handleCancel={cancelEditConfirmation}
              original={tsunami}
            >

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Date and Location</CardTitle>
                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-sm-2']} model=".year" label="Year" readOnly={updating} helpModalId="year" />
                    <LabeledText formGroupClassName={['col-sm-2']} model=".month" label="Month" readOnly={updating} helpModalId="month" />
                    <LabeledText formGroupClassName={['col-sm-2']} model=".day" label="Day" readOnly={updating} helpModalId="day" />
                    <LabeledText formGroupClassName={['col-sm-2']} model=".hour" label="Hour" readOnly={updating} helpModalId="hour" />
                    <LabeledText formGroupClassName={['col-sm-2']} model=".minute" label="Min" readOnly={updating} helpModalId="minute" />
                    <LabeledText formGroupClassName={['col-sm-2']} model=".second" label="Second" readOnly={updating} helpModalId="second" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-sm-6']} model=".latitude" label="Latitude" readOnly={updating} helpModalId="latitude" />
                    <LabeledText formGroupClassName={['col-sm-6']} model=".longitude" label="Longitude" readOnly={updating} helpModalId="longitude" />
                  </div>

                  <div className="form-row">
                    <LabeledSelect childOptions={locations.toJS()} formGroupClassName={['col-lg-6']} parentModel={model} fieldId="locationName" label="Location" readOnly={updating} filterable addable helpModalId="tsuLocationName" />
                    <LabeledSelect childOptions={regions.toJS()} formGroupClassName={['col-lg-6']} parentModel={model} fieldId="regionCode" label="Region" readOnly={updating} filterable prependId />
                  </div>

                  <div className="form-row">
                    <LabeledSelect childOptions={countries.toJS()} formGroupClassName={['col-md-6']} parentModel={model} fieldId="country" label="Country" readOnly={updating} filterable addable helpModalId="tsuCountry" />
                    <LabeledSelect childOptions={areas.toJS()} formGroupClassName={['col-md-6']} parentModel={model} fieldId="area" label="Area" readOnly={updating} filterable addable />
                  </div>

                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Measurements</CardTitle>

                  <div className="form-row">
                    <LabeledSelect childOptions={validities.toJS()} formGroupClassName={['col-md-6']} parentModel={model} fieldId="eventValidity" label="Validity" readOnly={updating} sorted={false} prependId helpModalId="tsuValidity" />
                    <LabeledSelect childOptions={causes.toJS()} formGroupClassName={['col-md-6']} parentModel={model} fieldId="causeCode" label="Cause" readOnly={updating} sorted={false} filterable prependId helpModalId="tsuCauseCode" />
                  </div>
                  <CardBody>
                    <div className="form-row">
                      <LabeledCheckbox inline model=".oceanicTsunami" label="Oceanic Tsunami" helpModalId="tsuOceanicTsunami" />
                    </div>
                  </CardBody>
                  <Card>
                    <CardBody>
                      <CardTitle>Tsunami Magnitude</CardTitle>

                      <div className="form-row">
                        <LabeledText formGroupClassName={['col-md-6']} model=".tsMtAbe" label="Abe" readOnly={updating} helpModalId="tsuMagAbe" />
                        <LabeledText formGroupClassName={['col-md-6']} model=".tsMtIi" label="Iida-Imamura" readOnly={updating} helpModalId="tsuMagIida" />
                      </div>

                    </CardBody>
                  </Card>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-lg-3']} model=".tsIntensity" label="Tsunami Intensity: Soloviev" readOnly={updating} helpModalId="tsuIntensity" />
                    <LabeledText formGroupClassName={['col-lg-3']} model=".maxWaterHeight" label="Max Water Height (m)" readOnly={updating} helpModalId="tsuMaxWaterHeight" />
                    <LabeledSelect childOptions={warningStatuses.toJS()} formGroupClassName={['col-lg-6']} parentModel={model} fieldId="warningStatusId" label="Tsunami Warning Status" readOnly={updating} sorted={false} prependId helpModalId="tsuWarnStatus" />
                  </div>

                </CardBody>
              </Card>


              <Card>
                <CardBody>
                  <CardTitle tag="h2">Effects</CardTitle>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".deaths" label="Deaths" readOnly={updating} helpModalId="deathsTotal" />
                    <LabeledSelect childOptions={peopleDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="deathsAmountOrder" label="Deaths Description" readOnly={updating} sorted={false} prependId helpModalId="deathDescription" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".missing" label="Missing" readOnly={updating} helpModalId="missing" />
                    <LabeledSelect childOptions={peopleDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="missingAmountOrder" label="Missing Description" readOnly={updating} sorted={false} prependId helpModalId="missingDescription" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".injuries" label="Injuries" readOnly={updating} helpModalId="injuries" />
                    <LabeledSelect childOptions={peopleDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="injuriesAmountOrder" label="Injuries Description" readOnly={updating} sorted={false} prependId helpModalId="injuriesDescription" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".damageMillionsDollars" label="Damage ($Mil)" readOnly={updating} helpModalId="damageTotal" />
                    <LabeledSelect childOptions={damageDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="damageAmountOrder" label="Damage Description" readOnly={updating} sorted={false} prependId helpModalId="damageDescription" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".housesDestroyed" label="Houses Destroyed" readOnly={updating} helpModalId="housesDestroyed" />
                    <LabeledSelect childOptions={housesDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="housesDestroyedAmountOrder" label="Houses Destroyed Description" readOnly={updating} sorted={false} prependId helpModalId="housesDestroyedDescription" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".housesDamaged" label="Houses Damaged" readOnly={updating} helpModalId="housesDamaged" />
                    <LabeledSelect childOptions={housesDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="housesDamagedAmountOrder" label="Houses Damaged Description" readOnly={updating} sorted={false} prependId helpModalId="housesDamagedDescription" />
                  </div>

                </CardBody>
              </Card>


              <Card>
                <CardBody>
                  <CardTitle tag="h2">Total Effects (Earthquake and Tsunami, Volcano, etc.)</CardTitle>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".deathsTotal" label="Total Deaths" readOnly={updating} helpModalId="deathsTotal" />
                    <LabeledSelect childOptions={peopleDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="deathsAmountOrderTotal" label="Total Deaths Description" readOnly={updating} sorted={false} prependId helpModalId="deathDescription" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".missingTotal" label="Total Missing" readOnly={updating} helpModalId="missing" />
                    <LabeledSelect childOptions={peopleDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="missingAmountOrderTotal" label="Total Missing Description" readOnly={updating} sorted={false} prependId helpModalId="missingDescription" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".injuriesTotal" label="Total Injuries" readOnly={updating} helpModalId="injuries" />
                    <LabeledSelect childOptions={peopleDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="injuriesAmountOrderTotal" label="Total Injuries Description" readOnly={updating} sorted={false} prependId helpModalId="injuriesDescription" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".damageMillionsDollarsTotal" label="Total Damage ($Mil)" readOnly={updating} helpModalId="damageTotal" />
                    <LabeledSelect childOptions={damageDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="damageAmountOrderTotal" label="Total Damage Description" readOnly={updating} sorted={false} prependId helpModalId="damageDescription" />
                  </div>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-md-6']} model=".housesDestroyedTotal" label="Total Houses Destroyed" readOnly={updating} helpModalId="housesDestroyed" />
                    <LabeledSelect childOptions={housesDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="housesDestroyedAmountOrderTotal" label="Total Houses Destroyed Description" readOnly={updating} sorted={false} prependId helpModalId="housesDestroyedDescription" />
                  </div>

                  <div>
                    <div className="form-row">
                      <LabeledText formGroupClassName={['col-md-6']} model=".housesDamagedTotal" label="Total Houses Damaged" readOnly={updating} helpModalId="housesDamaged" />
                      <LabeledSelect childOptions={housesDescriptorsJs} formGroupClassName={['col-md-6']} parentModel={model} fieldId="housesDamagedAmountOrderTotal" label="Total Houses Damaged Description" readOnly={updating} sorted={false} prependId helpModalId="housesDamagedDescription" />
                    </div>
                  </div>

                </CardBody>
              </Card>

              <AssociatedVolcanoControl
                model={model}
                volcano={volcano}
                volcanoSearching={volcanoSearching}
                volcanoSearchResults={volcanoSearchResults}
                searchVolcanoes={config => searchVolcanoes({ ...config, history })}
                sort={volSort}
                sortData={sortVolcanoes}
                visibleColumns={volVisibleColumns}
                toggleColumns={toggleVolcanoColumns}
              />

              <AssociatedEarthquakeControl
                model={model}
                earthquake={earthquake}
                searchEarthquakes={config => searchEarthquakes({ ...config, history })}
                earthquakeSearching={earthquakeSearching}
                earthquakeSearchResults={earthquakeSearchResults}
                sort={eqSort}
                visibleColumns={eqVisibleColumns}
                sortData={sortEarthquakes}
                toggleColumns={toggleEarthquakeColumns}
              />

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Earthquake Measurements</CardTitle>

                  <div className="form-row">
                    <LabeledText formGroupClassName={['col-12']} model=".eqDepth" label="Earthquake Depth" readOnly={updating} />
                  </div>

                  <Card>
                    <CardBody>
                      <CardTitle>Earthquake Magnitude</CardTitle>
                      <div className="form-row">
                        <LabeledText formGroupClassName={['col-md-2']} model=".eqMagUnk" label="UNK" readOnly={updating} />
                        <LabeledText formGroupClassName={['col-md-2']} model=".eqMagMb" label="MB" readOnly={updating} />
                        <LabeledText formGroupClassName={['col-md-2']} model=".eqMagMs" label="MS" readOnly={updating} />
                        <LabeledText formGroupClassName={['col-md-2']} model=".eqMagMw" label="MW" readOnly={updating} />
                        <LabeledText formGroupClassName={['col-md-2']} model=".eqMagMfa" label="MFA" readOnly={updating} />
                        <LabeledText formGroupClassName={['col-md-2']} model=".eqMagMl" label="ML" readOnly={updating} />
                      </div>
                    </CardBody>
                  </Card>
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Comments</CardTitle>
                  <CommentsEditor model={model} readOnly={updating} />
                </CardBody>
              </Card>

              <AssociatedReferenceControl
                model={model}
                initialReferences={references}
                searchReferences={config => searchReferences({ ...config, history })}
                referenceSearching={referenceSearching}
                referenceSearchResults={referenceSearchResults}
                sort={refSort}
                sortData={sortReferences}
                visibleColumns={refVisibleColumns}
                toggleColumns={toggleReferenceColumns}
              />

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Checks</CardTitle>

                  <div className="form-row">
                    <LabeledCheckbox inline model=".flagLocTimeChk" label="Location Time Checked" />
                    <LabeledCheckbox inline model=".flagMaxRunupChk" label="Max Runup Checked" />
                    <LabeledCheckbox inline model=".flagAllRunupsEnteredChk" label="All Runups Entered Checked" />
                    <LabeledCheckbox inline model=".flagAllRunupsSocioChk" label="All Runups Socio Checked" />
                    <LabeledCheckbox inline model=".flagEffectsChk" label="Effects Checked" />
                  </div>

                </CardBody>
              </Card>
              <Card>
                <CardBody>
                  <CardTitle tag="h2">Visibility</CardTitle>
                  <div className="form-row">
                    <LabeledCheckbox inline model=".publish" label="Publish" />
                  </div>
                </CardBody>
              </Card>

              <div>
                <Button disabled={updating || pristine} type="submit" color="primary" className="ml-5">{isAdd ? 'Create' : 'Update'}</Button>
                <Button disabled={updating || pristine} color="secondary" className="ml-2" onClick={this.resetForm}>Reset</Button>
                <Button disabled={updating} color="secondary" className="ml-2" onClick={this.cancel}>Cancel</Button>
              </div>
            </EditForm>

          </CardBody>
        </Card>


      </div>
    );
  }
}

TusnamiEditPageUnwrapped.propTypes = {
  clearTsunami: PropTypes.func.isRequired,
  searchReferences: PropTypes.func.isRequired,
  getReferences: PropTypes.func.isRequired,
  getTsunami: PropTypes.func.isRequired,
  searchVolcanoes: PropTypes.func.isRequired,
  getVolcano: PropTypes.func.isRequired,
  getEarthquake: PropTypes.func.isRequired,
  searchEarthquakes: PropTypes.func.isRequired,
  createTsunami: PropTypes.func.isRequired,
  updateTsunami: PropTypes.func.isRequired,
  earthquake: ImmutablePropTypes.map.isRequired,
  volcano: ImmutablePropTypes.map.isRequired,
  tsunami: ImmutablePropTypes.map.isRequired,
  references: ImmutablePropTypes.list.isRequired,
  match: PropTypes.shape({ params: PropTypes.shape({ id: PropTypes.string }) }).isRequired,
  fetched: PropTypes.bool.isRequired,
  updating: PropTypes.bool.isRequired,
  resetForm: PropTypes.func.isRequired,
  setPristine: PropTypes.func.isRequired,
  initializeForm: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  history: PropTypes.shape({ goBack: PropTypes.func }).isRequired,
  change: PropTypes.func.isRequired,
  referenceSearching: PropTypes.bool.isRequired,
  referenceSearchResults: ImmutablePropTypes.list.isRequired,
  earthquakeSearching: PropTypes.bool.isRequired,
  earthquakeSearchResults: ImmutablePropTypes.list.isRequired,
  volcanoSearching: PropTypes.bool.isRequired,
  volcanoSearchResults: ImmutablePropTypes.list.isRequired,
  getLocations: PropTypes.func.isRequired,
  getCountries: PropTypes.func.isRequired,
  getRegions: PropTypes.func.isRequired,
  getAreas: PropTypes.func.isRequired,
  getCauses: PropTypes.func.isRequired,
  getValidity: PropTypes.func.isRequired,
  getWarningStatuses: PropTypes.func.isRequired,
  regions: ImmutablePropTypes.list.isRequired,
  countries: ImmutablePropTypes.list.isRequired,
  areas: ImmutablePropTypes.list.isRequired,
  locations: ImmutablePropTypes.list.isRequired,
  causes: ImmutablePropTypes.list.isRequired,
  validities: ImmutablePropTypes.list.isRequired,
  warningStatuses: ImmutablePropTypes.list.isRequired,
  peopleDescriptors: ImmutablePropTypes.list.isRequired,
  damageDescriptors: ImmutablePropTypes.list.isRequired,
  housesDescriptors: ImmutablePropTypes.list.isRequired,
  sortVolcanoes: PropTypes.func.isRequired,
  volSort: ImmutablePropTypes.list.isRequired,
  sortEarthquakes: PropTypes.func.isRequired,
  eqSort: ImmutablePropTypes.list.isRequired,
  sortReferences: PropTypes.func.isRequired,
  refSort: ImmutablePropTypes.list.isRequired,
  openEditConfirmation: PropTypes.func.isRequired,
  cancelEditConfirmation: PropTypes.func.isRequired,
  formData: ImmutablePropTypes.map.isRequired,
  editConfirmationOpen: PropTypes.bool.isRequired,

  toggleEarthquakeColumns: PropTypes.func.isRequired,
  toggleReferenceColumns: PropTypes.func.isRequired,
  toggleVolcanoColumns: PropTypes.func.isRequired,
  eqVisibleColumns: ImmutablePropTypes.list.isRequired,
  volVisibleColumns: ImmutablePropTypes.list.isRequired,
  refVisibleColumns: ImmutablePropTypes.list.isRequired,
};

const defaultMap = Map();

const mapStateToProps = (state, props) => {
  const { match: { params: { id } } } = props;
  const isAdd = !id;

  const fetchedCheck = [
    state.getIn(['tsunamiEventEditPage', 'fetchedRegions']),
    state.getIn(['tsunamiEventEditPage', 'fetchedCountries']),
    state.getIn(['tsunamiEventEditPage', 'fetchedAreas']),
    state.getIn(['tsunamiEventEditPage', 'fetchedLocations']),
    state.getIn(['tsunamiEventEditPage', 'fetchedValidities']),
    state.getIn(['tsunamiEventEditPage', 'fetchedCauses']),
    state.getIn(['tsunamiEventEditPage', 'fetchedWarningStatuses']),
  ];
  if (!isAdd) {
    fetchedCheck.push(
      state.getIn(['tsunamiEventEditPage', 'fetched']),
      state.getIn(['tsunamiEventEditPage', 'fetchedVolcano']),
      state.getIn(['tsunamiEventEditPage', 'fetchedEarthquake']),
      state.getIn(['tsunamiEventEditPage', 'fetchedReferences']),
    );
  }

  const volcanoes = state.getIn(['tsunamiEventEditPage', 'volcano']);
  const earthquakes = state.getIn(['tsunamiEventEditPage', 'earthquake']);

  return {
    fetched: fetchedCheck.every(v => v),
    tsunami: state.getIn(['tsunamiEventEditPage', 'tsunami']),
    volcano: volcanoes.size ? volcanoes.get(0) : defaultMap,
    earthquake: earthquakes.size ? earthquakes.get(0) : defaultMap,
    references: state.getIn(['tsunamiEventEditPage', 'references']),
    pristine: state.get('forms')[model].$form.pristine,
    updating: state.getIn(['tsunamiEventEditPage', 'updating']),
    referenceSearching: state.getIn(['tsunamiEventEditPage', 'referenceSearching']),
    referenceSearchResults: state.getIn(['tsunamiEventEditPage', 'referenceSearchResults']),
    earthquakeSearching: state.getIn(['tsunamiEventEditPage', 'earthquakeSearching']),
    earthquakeSearchResults: state.getIn(['tsunamiEventEditPage', 'earthquakeSearchResults']),
    volcanoSearching: state.getIn(['tsunamiEventEditPage', 'volcanoSearching']),
    volcanoSearchResults: state.getIn(['tsunamiEventEditPage', 'volcanoSearchResults']),
    regions: state.getIn(['tsunamiEventEditPage', 'regions']),
    countries: state.getIn(['tsunamiEventEditPage', 'countries']),
    areas: state.getIn(['tsunamiEventEditPage', 'areas']),
    locations: state.getIn(['tsunamiEventEditPage', 'locations']),
    causes: state.getIn(['tsunamiEventEditPage', 'causes']),
    validities: state.getIn(['tsunamiEventEditPage', 'validities']),
    warningStatuses: state.getIn(['tsunamiEventEditPage', 'warningStatuses']),
    housesDescriptors: state.getIn(['effectDescriptors', 'houses']),
    damageDescriptors: state.getIn(['effectDescriptors', 'damage']),
    peopleDescriptors: state.getIn(['effectDescriptors', 'people']),
    volSort: state.getIn(['tsunamiEventEditPage', 'volSort']),
    eqSort: state.getIn(['tsunamiEventEditPage', 'eqSort']),
    refSort: state.getIn(['tsunamiEventEditPage', 'refSort']),
    volVisibleColumns: state.getIn(['tsunamiEventEditPage', 'volVisibleColumns']),
    refVisibleColumns: state.getIn(['tsunamiEventEditPage', 'refVisibleColumns']),
    eqVisibleColumns: state.getIn(['tsunamiEventEditPage', 'eqVisibleColumns']),
    formData: state.getIn(['tsunamiEventEditPage', 'formData']),
    editConfirmationOpen: state.getIn(['tsunamiEventEditPage', 'editConfirmationOpen']),
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  clearTsunami: clearTsunamiAc,
  searchReferences: searchReferencesAc,
  getReferences: getReferencesAc,
  getTsunami: getTsunamiAc,
  searchVolcanoes: searchVolcanoesAc,
  getVolcano: getVolcanoAc,
  getEarthquake: getEarthquakeAc,
  searchEarthquakes: searchEarthquakesAc,
  createTsunami: createTsunamiAc,
  updateTsunami: updateTsunamiAc,
  resetForm: () => actions.reset(model),
  change: (field, value) => actions.change(`${model}${field}`, value),
  initializeForm: volcanoLocation => actions.load(model, volcanoLocation),
  setPristine: () => actions.setPristine(model),
  getLocations: getLocationsAc,
  getCountries: getCountriesAc,
  getRegions: getRegionsAc,
  getAreas: getAreasAc,
  getCauses: getCausesAc,
  getValidity: getValidityAc,
  getWarningStatuses: getWarningStatusesAc,
  sortVolcanoes: sortVolcanoesAc,
  sortEarthquakes: sortEarthquakesAc,
  sortReferences: sortReferencesAc,
  openEditConfirmation: openEditConfirmationAc,
  cancelEditConfirmation: cancelEditConfirmationAc,
  toggleEarthquakeColumns: toggleEarthquakeColumnsAc,
  toggleVolcanoColumns: toggleVolcanoColumnsAc,
  toggleReferenceColumns: toggleReferenceColumnsAc,
}, dispatch);

export const TsunamiEditPage = connect(mapStateToProps, mapDispatchToProps)(TusnamiEditPageUnwrapped);
